import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { brandAdvantages, testimonials } from '@/mocks/comics';

export default function About() {
  return (
    <>
      <Navbar />
      <main>
        <section className="pt-20 pb-16 md:pb-20 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <nav className="flex items-center gap-2 text-xs text-foreground-500 mb-6" aria-label="面包屑导航">
              <Link to="/" className="hover:text-foreground-700 transition-colors">
                首页
              </Link>
              <i className="ri-arrow-right-s-line text-foreground-400"></i>
              <span className="text-foreground-800 font-medium">关于我们</span>
            </nav>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
              <div>
                <span className="text-accent-500 text-xs font-medium tracking-wide">
                  / 关于我们
                </span>
                <h1 className="text-3xl md:text-5xl font-heading font-bold text-foreground-900 mt-3 leading-snug">
                  致力于提供最佳韩漫阅读体验，让每一部好作品都能被看见
                </h1>
                <p className="text-foreground-600 text-sm leading-relaxed mt-6 max-w-xl">
                  韩漫网成立于 2025 年，是一个专注于韩漫免费阅读的平台。我们相信优质的漫画内容应该被更多人看到，因此始终坚持全站免费、无广告的纯净阅读模式。无论你偏爱浪漫的恋爱剧情，还是热血沸腾的动作场面，这里都有你最爱的作品。
                </p>
              </div>

              <div className="flex flex-col justify-center">
                <div className="flex items-center gap-2 mb-6 flex-wrap">
                  {[1, 2, 3, 4].map((i) => (
                    <div
                      key={i}
                      className="w-12 h-12 rounded-full bg-secondary-200 flex items-center justify-center"
                    >
                      <span className="text-foreground-600 text-xs font-semibold">
                        0{i}
                      </span>
                    </div>
                  ))}
                </div>
                <p className="text-foreground-500 text-xs mb-4">· 2025 成立</p>
                <p className="text-foreground-800 text-sm font-medium">
                  致力于最佳韩漫体验
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-background-50 py-16 md:py-20">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <span className="text-secondary-500 text-xs font-medium tracking-wider uppercase">
                品牌优势
              </span>
              <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-900 mt-3 leading-tight">
                信誉保障
                <br />
                用户至上
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {brandAdvantages.slice(0, 3).map((adv) => (
                <div
                  key={adv.title}
                  className="bg-background-100 rounded-lg p-6 md:p-7 transition-all duration-300 hover:bg-background-100/80"
                >
                  <div className="w-10 h-10 flex items-center justify-center text-foreground-800 mb-4">
                    <i className={`${adv.icon} text-2xl`} aria-label={adv.title}></i>
                  </div>
                  <h3 className="text-foreground-900 font-semibold text-base mb-2">
                    {adv.title}
                  </h3>
                  <p className="text-foreground-600 text-sm leading-relaxed">
                    {adv.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="bg-background-100 py-16 md:py-20">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="mb-10">
              <span className="inline-block bg-secondary-100 text-secondary-700 text-xs font-medium px-3 py-1 rounded-full">
                用户口碑
              </span>
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mt-4">
                来自读者的信任
              </h2>
            </div>

            <div className="columns-1 md:columns-2 lg:columns-3 gap-5">
              {testimonials.map((item) => (
                <div
                  key={item.id}
                  className="break-inside-avoid bg-background-50 rounded-lg p-5 mb-5"
                >
                  <div className="flex items-center gap-3 mb-3">
                    <img
                      src={item.avatar}
                      alt={item.name}
                      className="w-10 h-10 rounded-full object-cover"
                    />
                    <div>
                      <p className="text-foreground-900 font-semibold text-sm">
                        {item.name}
                      </p>
                      <p className="text-foreground-500 text-xs">
                        {item.username}
                      </p>
                    </div>
                  </div>
                  <p className="text-foreground-700 text-sm leading-relaxed">
                    &ldquo;{item.content}&rdquo;
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="bg-background-50 py-16 md:py-20">
          <div className="max-w-xl mx-auto px-4 md:px-6 text-center">
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
              联系我们
            </h2>
            <p className="text-foreground-600 text-sm leading-relaxed mb-8">
              有任何问题或建议，欢迎通过以下方式联系我们。我们会在 48 小时内回复。
            </p>
            <div className="space-y-3">
              <div className="flex items-center justify-center gap-2 text-foreground-700 text-sm">
                <i className="ri-mail-line text-accent-500"></i>
                <span>hello@bwpntxx.cn</span>
              </div>
              <div className="flex items-center justify-center gap-2 text-foreground-700 text-sm">
                <i className="ri-wechat-line text-accent-500"></i>
                <span>微信公众号：韩漫网HanMan</span>
              </div>
              <div className="flex items-center justify-center gap-2 text-foreground-700 text-sm">
                <i className="ri-weibo-line text-accent-500"></i>
                <span>微博：@韩漫网官方</span>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '韩漫网',
            url: 'http://bwpntxx.cn/',
            description: '韩漫画免费全集大全，下拉式无广告阅读，随时随地畅享各种漫画内容',
            foundingDate: '2025',
            contactPoint: {
              '@type': 'ContactPoint',
              email: 'hello@bwpntxx.cn',
              contactType: 'customer service',
            },
            sameAs: ['http://bwpntxx.cn/'],
          }),
        }}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '关于我们 - 韩漫网',
            description: '了解韩漫网的品牌理念、信誉保障与联系方式',
            url: 'http://bwpntxx.cn/about',
            isPartOf: {
              '@type': 'WebSite',
              name: '韩漫网',
              url: 'http://bwpntxx.cn/',
            },
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                {
                  '@type': 'ListItem',
                  position: 1,
                  name: '首页',
                  item: 'http://bwpntxx.cn/',
                },
                {
                  '@type': 'ListItem',
                  position: 2,
                  name: '关于我们',
                  item: 'http://bwpntxx.cn/about',
                },
              ],
            },
          }),
        }}
      />
    </>
  );
}